export default function SubscriptionGate({ children }: { children: React.ReactNode }) {
  return <>{children}</>;
}
